// React i hooks
import { memo } from "react";

// Tipovi i konstante
import { AccountDetailCardProps } from "./types";

// UI komponente
import ProfileInfoCard from "./components/ProfileInfoCard/ProfileInfoCard";
import PasswordInfoCard from "./components/PasswordInfoCard/PasswordInfoCard";

const AccountDetailCard: React.FC<AccountDetailCardProps> = () => {
  return (
    <div className="divide-y divide-slate-200">
      <ProfileInfoCard />
      <PasswordInfoCard />
    </div>
  );
};

export default memo(AccountDetailCard);
